(() => {
  if (window.esenseraSearchExperienceInitialised) {
    return;
  }

  window.esenseraSearchExperienceInitialised = true;

  const STORAGE_KEY = "esenseraRecentSearches";
  const FOCUS_AFTER_CLEAR_KEY = "esenseraFocusSearchAfterClear";
  const MINIMUM_QUERY_LENGTH = 3;
  const DEFAULT_MAXIMUM_RECENT_SEARCHES = 6;
  const DEFAULT_POPULAR_SEARCHES = [
    "Nye produkter",
    "Citrus",
    "Oud",
    "Åndedræt",
    "Afslapning"
  ];

  const isDanish = document.documentElement.lang
    .toLowerCase()
    .startsWith("da");

  const RECENT_HEADING = isDanish
    ? "Tidligere søgninger"
    : "Recent searches";

  const CLEAR_LABEL = isDanish
    ? "Ryd"
    : "Clear";

  const normalizeTerm = (value) =>
    String(value || "")
      .normalize("NFC")
      .toLocaleLowerCase("da-DK")
      .trim()
      .replace(/\s+/g, " ");

  const readJson = (selector) => {
    const element = document.querySelector(selector);

    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent.trim());
    } catch (error) {
      console.warn(
        "ESENSERA søgekonfiguration kunne ikke læses:",
        error
      );
      return null;
    }
  };

  const config =
    readJson("[data-esensera-search-discovery-config]") || {};

  const popularSearches = Array.isArray(config.popularSearches)
    ? config.popularSearches
        .map((value) => String(value || "").trim())
        .filter(Boolean)
    : DEFAULT_POPULAR_SEARCHES;

  const maximumRecentSearches = Math.max(
    1,
    Number(
      config.maximumRecentSearches ||
        DEFAULT_MAXIMUM_RECENT_SEARCHES
    )
  );

  const recentSearchesEnabled =
    config.enableRecentSearches !== false;

  const getShopRoot = () => {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  };

  const getSearchRoute = () =>
    config.searchUrl || `${getShopRoot()}search`;

  const buildSearchUrl = (query) => {
    const url = new URL(
      getSearchRoute(),
      window.location.origin
    );

    url.searchParams.set("q", String(query || "").trim());
    url.searchParams.set("options[prefix]", "last");
    url.searchParams.set(
      "options[unavailable_products]",
      "show"
    );
    url.searchParams.set("type", "all");
    url.searchParams.set(
      "options[fields]",
      "title,variants.title,variants.sku"
    );

    return `${url.pathname}${url.search}`;
  };


  const getSearchFormForDiscoveryLink = (searchLink) => {
    const directForm = searchLink?.closest?.("form[role='search']");

    if (directForm) {
      return directForm;
    }

    const discoveryBlock = searchLink?.closest?.(
      "[data-esensera-search-discovery]"
    );

    const context = discoveryBlock?.getAttribute(
      "data-esensera-search-discovery-context"
    );

    if (context === "drawer") {
      return (
        searchLink.closest?.("action-search")?.querySelector(
          "form[role='search']"
        ) || document.querySelector("#search_mini_form")
      );
    }

    if (context === "page") {
      return document.querySelector(
        "form[data-esensera-main-search-form]"
      );
    }

    return (
      searchLink.closest?.("action-search")?.querySelector(
        "form[role='search']"
      ) ||
      document.querySelector(
        "form[data-esensera-main-search-form], #search_mini_form"
      )
    );
  };

  const readRecentSearches = () => {
    try {
      const storedValue = window.localStorage.getItem(
        STORAGE_KEY
      );

      const parsedValue = storedValue
        ? JSON.parse(storedValue)
        : [];

      return Array.isArray(parsedValue)
        ? parsedValue
            .map((value) => String(value || "").trim())
            .filter(Boolean)
            .slice(0, maximumRecentSearches)
        : [];
    } catch (error) {
      return [];
    }
  };

  const writeRecentSearches = (searches) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(searches)
      );
    } catch (error) {
      // Privat browsing kan blokere localStorage.
    }
  };

  const createSearchIcon = () => {
    const icon = document.createElement("span");
    icon.className = "esensera-search-recent-dropdown__icon";
    icon.setAttribute("aria-hidden", "true");
    icon.innerHTML = `
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10.8" cy="10.8" r="6.8" stroke="currentColor" stroke-width="1.7"></circle>
        <path d="M16 16L21 21" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"></path>
      </svg>
    `;
    return icon;
  };

  const createPopularSearchLink = (query) => {
    const wrapper = document.createElement("span");
    wrapper.setAttribute("role", "listitem");

    const link = document.createElement("a");
    link.className =
      "esensera-search-discovery__chip active-facets__button active-facets__button--light remove-underline hover-as-fill-button accent-color-second-bg heading-color fs-small rounded-corner-item";
    link.href = buildSearchUrl(query);
    link.textContent = query;
    link.setAttribute(
      "data-esensera-search-discovery-link",
      ""
    );
    link.setAttribute(
      "data-esensera-search-query",
      query
    );

    wrapper.appendChild(link);
    return wrapper;
  };

  const createRecentSearchLink = (query) => {
    const link = document.createElement("a");
    link.className =
      "esensera-search-recent-dropdown__option remove-underline heading-color";
    link.href = buildSearchUrl(query);
    link.setAttribute("role", "option");
    link.setAttribute(
      "data-esensera-search-discovery-link",
      ""
    );
    link.setAttribute(
      "data-esensera-search-query",
      query
    );

    link.appendChild(createSearchIcon());

    const label = document.createElement("span");
    label.className =
      "esensera-search-recent-dropdown__label";
    label.textContent = query;
    link.appendChild(label);

    return link;
  };

  const renderDiscoveryBlocks = () => {
    document
      .querySelectorAll("[data-esensera-search-discovery]")
      .forEach((discoveryBlock) => {
        const popularContainer =
          discoveryBlock.querySelector(
            "[data-esensera-popular-searches]"
          );

        if (popularContainer) {
          popularContainer.replaceChildren(
            ...popularSearches.map(
              createPopularSearchLink
            )
          );
        }
      });
  };

  const hideRecentDropdown = (dropdown) => {
    if (!dropdown) {
      return;
    }

    dropdown.hidden = true;
    dropdown.removeAttribute("data-esensera-open");
  };

  const getMatchingRecentSearches = (input) => {
    const query = normalizeTerm(input?.value);

    if (query.length >= MINIMUM_QUERY_LENGTH) {
      return [];
    }

    const recentSearches = readRecentSearches();

    if (!query) {
      return recentSearches;
    }

    return recentSearches.filter((recentSearch) =>
      normalizeTerm(recentSearch).startsWith(query)
    );
  };

  const renderRecentDropdown = (dropdown) => {
    if (!dropdown) {
      return;
    }

    const form = dropdown.closest("form");
    const input = form?.querySelector(
      "input[type='search'][name='q']"
    );
    const optionsContainer = dropdown.querySelector(
      "[data-esensera-recent-search-options]"
    );
    const clearButton = dropdown.querySelector(
      "[data-esensera-clear-recent-searches]"
    );

    if (!form || !input || !optionsContainer) {
      hideRecentDropdown(dropdown);
      return;
    }

    const matchingSearches =
      getMatchingRecentSearches(input);

    optionsContainer.replaceChildren(
      ...matchingSearches.map(createRecentSearchLink)
    );

    if (clearButton) {
      clearButton.hidden =
        readRecentSearches().length === 0;
    }

    const formHasFocus = form.contains(
      document.activeElement
    );

    const shouldShow =
      formHasFocus && matchingSearches.length > 0;

    dropdown.hidden = !shouldShow;
    dropdown.toggleAttribute(
      "data-esensera-open",
      shouldShow
    );
  };

  const renderRecentDropdowns = () => {
    document
      .querySelectorAll(
        "[data-esensera-recent-search-dropdown]"
      )
      .forEach(renderRecentDropdown);
  };

  const saveSearch = (query) => {
    const trimmedQuery = String(query || "").trim();

    if (
      normalizeTerm(trimmedQuery).length <
      MINIMUM_QUERY_LENGTH
    ) {
      return;
    }

    const normalizedQuery = normalizeTerm(trimmedQuery);
    const nextSearches = [
      trimmedQuery,
      ...readRecentSearches().filter(
        (storedQuery) =>
          normalizeTerm(storedQuery) !== normalizedQuery
      )
    ].slice(0, maximumRecentSearches);

    writeRecentSearches(nextSearches);
    renderRecentDropdowns();
  };

  const clearRecentSearches = () => {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      writeRecentSearches([]);
    }

    renderRecentDropdowns();
  };

  const createRecentDropdown = (form, index) => {
    if (!recentSearchesEnabled) {
      return;
    }

    const input = form.querySelector(
      "input[type='search'][name='q']"
    );

    if (
      !input ||
      form.querySelector(
        "[data-esensera-recent-search-dropdown]"
      )
    ) {
      return;
    }

    form.setAttribute(
      "data-esensera-search-form-with-history",
      ""
    );

    const dropdown = document.createElement("div");
    dropdown.className =
      "esensera-search-recent-dropdown bg-default rounded-corner-item";
    dropdown.setAttribute(
      "data-esensera-recent-search-dropdown",
      ""
    );
    dropdown.setAttribute("role", "region");
    dropdown.hidden = true;

    const headingRow = document.createElement("div");
    headingRow.className =
      "esensera-search-recent-dropdown__heading-row";

    const heading = document.createElement("span");
    heading.className =
      "esensera-search-recent-dropdown__heading heading-color";
    heading.textContent = RECENT_HEADING;
    headingRow.appendChild(heading);

    const clearButton = document.createElement("button");
    clearButton.type = "button";
    clearButton.className =
      "esensera-search-recent-dropdown__clear btn-reset heading-color";
    clearButton.textContent = CLEAR_LABEL;
    clearButton.setAttribute(
      "data-esensera-clear-recent-searches",
      ""
    );
    headingRow.appendChild(clearButton);

    const options = document.createElement("div");
    options.className =
      "esensera-search-recent-dropdown__options";
    options.id = `EsenseraRecentSearchOptions-${index}`;
    options.setAttribute("role", "listbox");
    options.setAttribute(
      "data-esensera-recent-search-options",
      ""
    );

    dropdown.appendChild(headingRow);
    dropdown.appendChild(options);
    form.appendChild(dropdown);

    input.addEventListener("focus", () => {
      renderRecentDropdown(dropdown);
    });

    input.addEventListener("click", () => {
      renderRecentDropdown(dropdown);
    });

    input.addEventListener("input", () => {
      renderRecentDropdown(dropdown);
    });

    input.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        hideRecentDropdown(dropdown);
        return;
      }

      if (
        event.key === "ArrowDown" &&
        !dropdown.hidden
      ) {
        const firstOption = dropdown.querySelector(
          "[role='option']"
        );

        if (firstOption) {
          event.preventDefault();
          firstOption.focus();
        }
      }
    });

    dropdown.addEventListener("keydown", (event) => {
      const currentOption = event.target.closest?.(
        "[role='option']"
      );

      if (!currentOption) {
        return;
      }

      const optionsList = Array.from(
        dropdown.querySelectorAll("[role='option']")
      );
      const currentIndex = optionsList.indexOf(
        currentOption
      );

      if (event.key === "ArrowDown") {
        event.preventDefault();
        optionsList[
          Math.min(currentIndex + 1, optionsList.length - 1)
        ]?.focus();
      } else if (event.key === "ArrowUp") {
        event.preventDefault();

        if (currentIndex <= 0) {
          input.focus();
        } else {
          optionsList[currentIndex - 1]?.focus();
        }
      } else if (event.key === "Escape") {
        event.preventDefault();
        hideRecentDropdown(dropdown);
        input.focus();
      }
    });

    form.addEventListener("focusout", () => {
      window.setTimeout(() => {
        if (!form.contains(document.activeElement)) {
          hideRecentDropdown(dropdown);
        }
      }, 0);
    });
  };

  const initialiseRecentDropdowns = () => {
    const forms = Array.from(
      document.querySelectorAll(
        "#search_mini_form, [data-esensera-main-search-form]"
      )
    );

    forms.forEach(createRecentDropdown);

    document.addEventListener("pointerdown", (event) => {
      document
        .querySelectorAll(
          "[data-esensera-recent-search-dropdown]"
        )
        .forEach((dropdown) => {
          const form = dropdown.closest("form");

          if (form && !form.contains(event.target)) {
            hideRecentDropdown(dropdown);
          }
        });
    });
  };

  const focusInput = (input) => {
    if (!input || input.disabled) {
      return;
    }

    try {
      input.focus({ preventScroll: true });
    } catch (error) {
      input.focus();
    }

    const valueLength = input.value.length;

    try {
      input.setSelectionRange(
        valueLength,
        valueLength
      );
    } catch (error) {
      // Ikke alle inputtyper understøtter setSelectionRange.
    }
  };

  const scheduleDrawerFocus = () => {
    const input = document.querySelector(
      "action-search.header-search input[type='search']"
    );

    const focusAndShowHistory = () => {
      focusInput(input);
      renderRecentDropdowns();
    };

    focusAndShowHistory();

    [80, 360].forEach((delay) => {
      window.setTimeout(focusAndShowHistory, delay);
    });
  };

  const initialiseDrawerFocus = () => {
    const drawer = document.querySelector(
      "action-search.header-search"
    );

    document.addEventListener("click", (event) => {
      if (
        event.target.closest?.("#search-icon-bubble")
      ) {
        scheduleDrawerFocus();
      }
    });

    if (!drawer) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (
        drawer.hasAttribute("open") ||
        drawer.classList.contains("active")
      ) {
        scheduleDrawerFocus();
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["class", "open"]
    });
  };

  const clearFullSearch = () => {
    const controller =
      window.esenseraFullSearchController;

    if (
      controller &&
      typeof controller.clearSearchExperience ===
        "function" &&
      controller.clearSearchExperience()
    ) {
      renderRecentDropdowns();
      return;
    }

    try {
      window.sessionStorage.setItem(
        FOCUS_AFTER_CLEAR_KEY,
        "true"
      );
    } catch (error) {
      // Fokus forsøges stadig efter navigation.
    }

    window.location.assign(getSearchRoute());
  };

  const initialiseFullSearchClear = () => {
    document.addEventListener(
      "click",
      (event) => {
        const clearButton = event.target.closest(
          ".page_search .clear-btn"
        );

        if (!clearButton) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        clearFullSearch();
      },
      true
    );

    document.addEventListener(
      "keydown",
      (event) => {
        const clearButton = event.target.closest?.(
          ".page_search .clear-btn"
        );

        if (
          !clearButton ||
          !["Enter", " "].includes(event.key)
        ) {
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        clearFullSearch();
      },
      true
    );
  };

  const restoreFullSearchFocus = () => {
    let shouldFocus = false;

    try {
      shouldFocus =
        window.sessionStorage.getItem(
          FOCUS_AFTER_CLEAR_KEY
        ) === "true";

      if (shouldFocus) {
        window.sessionStorage.removeItem(
          FOCUS_AFTER_CLEAR_KEY
        );
      }
    } catch (error) {
      shouldFocus = false;
    }

    if (!shouldFocus) {
      return;
    }

    const input = document.querySelector(
      "[data-esensera-main-search-form] input[name='q']"
    );

    [0, 120].forEach((delay) => {
      window.setTimeout(() => {
        focusInput(input);
        renderRecentDropdowns();
      }, delay);
    });
  };

  const initialiseSearchSaving = () => {
    document.addEventListener(
      "submit",
      (event) => {
        const form = event.target.closest?.(
          "form[role='search']"
        );

        if (!form) {
          return;
        }

        const query = form.querySelector(
          "input[name='q']"
        )?.value;

        saveSearch(query);
      },
      true
    );

    const fullSearchConfig = readJson(
      "[data-esensera-full-search-config]"
    );

    if (fullSearchConfig?.query) {
      saveSearch(fullSearchConfig.query);
    }
  };

  document.addEventListener("click", (event) => {
    const clearButton = event.target.closest(
      "[data-esensera-clear-recent-searches]"
    );

    if (clearButton) {
      event.preventDefault();
      clearRecentSearches();
      return;
    }

    const searchLink = event.target.closest(
      "[data-esensera-search-discovery-link]"
    );

    if (searchLink) {
      const query = String(
        searchLink.getAttribute(
          "data-esensera-search-query"
        ) || searchLink.textContent || ""
      ).trim();

      saveSearch(query);

      /*
       * En tidligere eller populær søgning skal gå gennem præcis samme
       * submit-logik som en manuelt indtastet søgning. Dermed bliver rene
       * typesøgninger, filterintentioner og produktsøgninger sendt til den
       * samme destination uanset indgang.
       */
      const form = getSearchFormForDiscoveryLink(searchLink);
      const input = form?.querySelector(
        "input[type='search'][name='q']"
      );

      if (form && input && query) {
        event.preventDefault();
        input.value = query;

        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.dispatchEvent(
            new Event("submit", {
              bubbles: true,
              cancelable: true
            })
          );
        }
      }
    }
  });

  const renderSearchExperience = () => {
    renderDiscoveryBlocks();
    renderRecentDropdowns();
  };

  const initialise = () => {
    initialiseRecentDropdowns();
    renderSearchExperience();
    initialiseDrawerFocus();
    initialiseFullSearchClear();
    initialiseSearchSaving();
    restoreFullSearchFocus();
  };

  window.EsenseraSearchHistory = {
    save: saveSearch,
    clear: clearRecentSearches,
    render: renderSearchExperience,
    buildSearchUrl
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialise
    );
  } else {
    initialise();
  }
})();
